// extracted by mini-css-extract-plugin
export default {"botonEdicion":"BotoneraJugador_botonEdicion__kbuId","botonCambio":"BotoneraJugador_botonCambio__oARW5","botonTarjeta":"BotoneraJugador_botonTarjeta__2aaBA"};